<!doctype html>
<html lang="en">
  <head>
    <title>Print Case Behavior</title>
  </head>
  <body id="pdf-data" #pdfContent>
    <div class="pdf-content">
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"5%"}'>
          <img
            [src]="printData?.logo"
            alt="orgLogo"
            style="width: 100px; height: auto; object-fit: contain" />
        </div>

        <div data-pdfmake='{"width":"*", "margin": [10, 0]}'>
          <div class="desc" style="text-align: right">
            {{ printData?.orgDetail.address }}
          </div>
          <div class="address" style="text-align: right">
            {{ printData?.orgDetail.city }}, {{ printData?.orgDetail.state }},
            {{ printData?.orgDetail.country }},
            {{ printData?.orgDetail.zipCode }}
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div class="title" data-pdfmake='{"width":"*"}'>
          {{ printData?.caseParams.case.student.firstName }}
          {{ printData?.caseParams.case.student.lastName }}
        </div>
        <div style="width: auto"></div>
        <div
          class="title"
          style="text-align: right"
          data-pdfmake='{"width":"*"}'>
          <b>Supervisor : </b>
          {{ printData?.caseParams.case.supervisorName || '-' }}
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />

      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Gender</div>
          <div class="dataValue">
            <b> {{ printData?.caseParams.case.student.gender }}</b>
          </div>
        </div>
        <div style="width: auto">
          <div class="datalabel">Student School</div>
          <div class="dataValue">
            <b>{{ printData?.caseParams.case.student.organizationName }}</b>
          </div>
        </div>
        <div style="text-align: left" data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Date Of Birth</div>
          <div class="dataValue">
            <b>{{
              printData?.caseParams.case.student.dateOfBirth
                | userDate: 'MM/dd/yyyy'
            }}</b>
          </div>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":"*"}'>
          <div class="datalabel">Notes</div>
          <div class="dataValue">
            <b>{{ printData?.caseParams.case.note || 'Nothing Entered' }}</b>
          </div>
        </div>
      </div>

      <hr data-pdfmake='{"color": "#eaecf0", "thickness": 1, "width": 552}' />
      <div
        style="font-size: 18px"
        data-pdfmake='{
          "color": "#128E55"
      }'>
        <b> Target Behavior > {{ printData?.form.behaviorCategoryId }}</b>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Behavior Types :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b>{{
            printData?.form.caseBehaviorTypeIds?.length > 0
              ? printData?.form.caseBehaviorTypeIds.join(', ')
              : 'None Selected'
          }}</b>

          <b>{{
            printData?.form.caseBehaviorTypeDescriptions?.length > 0
              ? ', Other- ' +
                printData?.form.caseBehaviorTypeDescriptions.join(', ')
              : ''
          }}</b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Operational Definition :
        </div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b
            >{{ printData?.form.operationalDefinition || 'Nothing Entered' }}
          </b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">Frequency :</div>
        <div data-pdfmake='{"width":"*"}' class="datalabel">
          <b>{{
            !!printData?.form.behaviourFrequencyId
              ? getFrequencyAnswer()
              : 'None Selected'
          }}</b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">Intensity :</div>
        <div data-pdfmake='{"width":"*"}' class="dataValue">
          <b>{{
            !!printData?.form.behaviourIntensityId
              ? printData?.form.behaviourIntensityId
              : 'None Selected'
          }}</b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">Environments :</div>
        <div data-pdfmake='{"width":"*"}' class="dataValue">
          <b>
            {{
              printData?.form.caseBehaviorEnvironmentIds?.length > 0
                ? printData?.form.caseBehaviorEnvironmentIds.join(', ')
                : 'None Selected'
            }}
          </b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">
          Setting Events :
        </div>
        <div data-pdfmake='{"width":"*"}' class="dataValue">
          <b>
            {{
              printData?.form.caseBehaviorSettingEventIds?.length > 0
                ? printData?.form.caseBehaviorSettingEventIds.join(', ')
                : 'None Selected'
            }}</b
          >
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">Antecedents :</div>
        <div data-pdfmake='{"width":"*"}' class="dataValue">
          <b>
            {{
              printData?.form.caseBehaviorAntecedentIds?.length > 0
                ? printData?.form.caseBehaviorAntecedentIds.join(', ')
                : 'None Selected'
            }}</b
          >
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">Consequences :</div>
        <div data-pdfmake='{"width":"*"}' class="dataValue">
          <b>
            {{
              printData?.form.caseBehaviorConsequenceIds?.length > 0
                ? printData?.form.caseBehaviorConsequenceIds.join(', ')
                : 'None Selected'
            }}
          </b>
          <b>{{
            printData?.form.caseBehaviorConsequenceDescription?.length > 0
              ? ', Other- ' +
                printData?.form.caseBehaviorConsequenceDescription.join(', ')
              : ''
          }}</b>
        </div>
      </div>
      <br />
      <div data-pdfmake-type="columns">
        <div data-pdfmake='{"width":175}' class="datalabel">Goals :</div>
        <div data-pdfmake='{"width":"*"}' class="dataValue">
          <b> {{ printData?.form.goals || 'Nothing Entered' }}</b>
        </div>
      </div>
      <br />
      <div
        *ngFor="
          let question of printData?.form.caseBehaviorCustomQuestionAnswer
        ">
        <div data-pdfmake-type="columns">
          <div data-pdfmake='{"width":175}' class="datalabel">
            {{ question?.customQuestion + ' :' }}
          </div>
          <div data-pdfmake='{"width":"*"}' class="dataValue">
            <b> {{ question?.answer || 'Nothing Entered' }}</b>
          </div>
        </div>
        <br />
      </div>
    </div>
  </body>
</html>
